import { api } from "../httpClient";
import { API_ENDPOINTS } from "../config";


export const getPaymentCredentials = async (payload) => {
  try {
    const response = await api.post(
      API_ENDPOINTS.PAYMENT_CREDENTIALS,
      payload
    );

    return response;
  } catch (error) {
    console.error("Payment credentials failed:", error);
    throw error;
  }
};

export const getFiservConfig = async (reservationId) => {
  try {
    const response = await api.get(API_ENDPOINTS.FISERV_CONFIG, {
      params: { reservationId  },
    });

    // Your server.js wraps the decrypted JSON in a Base64 string called 'payload'
    const obfuscatedData = response.payload; 
    if (!obfuscatedData) throw new Error("Missing payload from server");

    // Decode the Base64 string back into a JSON string, then parse it
    const decodedString = atob(obfuscatedData);
    const data = JSON.parse(decodedString);

    // console.log("Raw Data from Backend:", data);

    // Normalize the keys to match what fiservProvider.js expects
    const normalizedConfig = {
      environment: data.environment, 
      apiKey: data.api_key,
      merchantId: data.merchant_id,
      terminalId: data.terminal_id,
      pageId: data.hosted_page_id,
      pageVersion: data.page_version,
      sdk_url: data.sdk_url,
      requires3DS: data.requires3ds !== false,
    };
    // console.log("normalizedConfig", normalizedConfig);

    return normalizedConfig;
  } catch (error) {
    console.error("getFiservConfig error:", error);
    throw error;
  }
};

export const getStripeConfig = async (reservationId) => {
  // ← no currency param needed, reservation param needed
  try {
    const response = await api.get(API_ENDPOINTS.STRIPE_CONFIG, {
      params: { reservationId: reservationId },
      headers: { "Cache-Control": "no-cache" },
    });

    const obfuscatedData = response?.payload ?? response?.data?.payload;
    if (!obfuscatedData) throw new Error("Missing Stripe config payload");

    const data = JSON.parse(atob(obfuscatedData));
    if (!data.publish_key) throw new Error("Missing api_key in Stripe config");

    if (!data.client_secret)
      throw new Error("Missing client_secret in Stripe config");

    return {
      publishableKey: data.publish_key,
      clientSecret: data.client_secret,
    };
  } catch (error) {
    console.error("getStripeConfig error:", error);
    throw error;
  }
};